module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularWeb-MediumItalic.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularWeb-MediumItalic.eot
 ** module id = 355
 ** module chunks = 0
 **/